module.exports = __webpack_public_path__ + "6dfe3442ac09808871d4cc4ca300ae5c.pdf";